import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Select2OptionData } from 'ng-select2';
import { ToastrService } from 'ngx-toastr';
import { CreateResult } from '../models/create-result';
import { ParticipantViewModel } from '../models/participant-view-model';
import { ParticipantService } from '../services/participant.service';
import { AuthenticationService } from '../services/authentication.service';
import { UserDataStoreService } from '../services/user-data-store.service';
import { PermissionEnum } from '../services/guards/permissions';
import { ConfirmationDialogComponent } from '../partials/confirmation-dialog/confirmation-dialog.component';
import { CardAcceptorConfigService } from '../services/card-acceptor-config.service';
import { CommsProfileParticipantLinkViewModel } from "../models/comms-profile-participant-link";
import { TerminalService } from "../services/terminal.service";
import { CommsProfileService } from "../services/comms-profile.service";
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-comms-profile-mapping-view',
  templateUrl: './comms-profile-mapping-view.component.html',
  styleUrls: ['./comms-profile-mapping-view.component.scss']
})
export class CommsProfileMappingViewComponent implements OnInit {

  public commsProfiles: Select2OptionData[];
  public allcommsProfiles: Select2OptionData[];
  public mapCustomCommsProfiles: Select2OptionData[];

  public participant: ParticipantViewModel;
  public commsProfilesByParticipant: CommsProfileParticipantLinkViewModel[] = [];

  public createResult: CreateResult;
  public canEdit: boolean;
  errorMessage: string;
  error: boolean;
  public selectedCommsProfile: string;

  public select2options: any = {
    multiple: false,
    width: '100%',
    allowClear: true
  };

  constructor(private _modalService: NgbModal,
    private _cardAcceptorConfigService: CardAcceptorConfigService,
    private _participantService: ParticipantService,
    private _commsProfileService: CommsProfileService,
    private _authenticationService: AuthenticationService,
    private _terminalService: TerminalService,
    private _toastService: ToastrService,
    private _userDataStore: UserDataStoreService,
    private _route: ActivatedRoute,
    private _ngxUiLoaderService: NgxUiLoaderService) {
    this._route.params.subscribe(async params => {
      this.canEdit = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditParticipantConfiguration], []);
      await this.initParticipant(params.id);


      this.commsProfiles = (await this._commsProfileService.GetCommsProfiles()).map((x) => {
        return { id: x.commsProfileId.toString(), text: x.description }
      });
      this.commsProfilesByParticipant = await this._commsProfileService.GetCommsProfileByParticipant(params.id);
      this.filterCommsProfiles();
    });
  }

  public async ngOnInit(): Promise<void> {

  }

  public async initParticipant(id: number): Promise<void> {
    this.participant = await this._participantService.GetParticipant(id);
  }

  public filterCommsProfiles(): void {
    this.mapCustomCommsProfiles = this.commsProfiles.filter((item) => {
      if (this.commsProfilesByParticipant != null) {
        const index = this.commsProfilesByParticipant.findIndex(x => x.commsProfileId.toString() === item.id);
        if (index > -1) {
          return false;
        }
      }
      return true;
    });
  }

  public async save(): Promise<void> {

    if (!this.canEdit) {
      this._toastService.error('You do not have the required permissions to perform this action.', 'Error');
    } else {
      this.createResult = await this._commsProfileService.DeleteCommsProfileByParticipantId(this.participant.id);
      if (this.createResult.success) {
        this.createResult = await this._commsProfileService.UpdateCommsProfiles(this.commsProfilesByParticipant);
        if (this.createResult.success) {
          this._toastService.success(this.createResult.message, 'Success');
        } else {
          this._toastService.error(this.createResult.message, 'Error');
        }
      } else {
        this._toastService.error(this.createResult.message, 'Error');
      }
    }
  }

  public addComsProfile(): void {
    if (this.selectedCommsProfile == null) {
      alert('Select a Comms Profile');
    } else {
      this.commsProfilesByParticipant.push({
        commsProfileId: parseInt(this.selectedCommsProfile),
        description: this.commsProfiles.find(x => x.id == this.selectedCommsProfile).text,
        participantId: this.participant.id,
      });
      this.filterCommsProfiles();
    }
  }

  public deleteMappedField(commsProfile: number): void {
    const index = this.commsProfilesByParticipant.findIndex(x => x.commsProfileId == commsProfile);
    if (index > -1) {
      this.commsProfilesByParticipant.splice(index, 1);
    }
    this.filterCommsProfiles();
  }

  public async determineDeleteDialog(commsProfile: number) {
    this._ngxUiLoaderService.start();
    var terminals = await this._terminalService.CountTerminals(commsProfile);
    this._ngxUiLoaderService.stop();
    if (terminals === 0) {
      await this.openDeleteConfirmationDialog(commsProfile);
    } else {
      await this.openUsedDeleteFailureConfirmationDialog(terminals);
    }
  }

  public async openDeleteConfirmationDialog(commsProfile: number) {
    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = true;
    dialogRef.componentInstance.acceptButtonText = 'Yes';
    dialogRef.componentInstance.cancelButtonText = 'No'
    dialogRef.componentInstance.title = 'Comms Profile Removal'
    dialogRef.componentInstance.message = 'Are you sure you want to delete the selected comms profile?'

    const result = await dialogRef.result;
    if (result) {
      await this.deleteMappedField(commsProfile);
    }
  }

  public async openUsedDeleteFailureConfirmationDialog(count: number) {
    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.acceptButtonText = 'OK'
    dialogRef.componentInstance.title = 'Comms Profile Cannot Be Removed'
    dialogRef.componentInstance.message = `The comms profile is currently in use by ${count} terminals and cannot be deleted.`
  }
}

